import { Box, Divider } from '@mui/material';
import { common } from '@mui/material/colors';
import BaseDialog from 'common/components/base-dialog';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import imgGuideActive from 'assets/images/active-account-guide.svg';
import imgGuideChangePassword from 'assets/images/change-password-guide.svg';
import { colors } from 'common/constants';
import facebook from 'assets/images/icons/facebook.svg';
import globe from 'assets/images/icons/globe.svg';
import youtube from 'assets/images/icons/youtube.svg';
import mail from 'assets/images/icons/mail.svg';
interface RegisterSuccessDialogProps {
    title: string;
    open: boolean;
    onClose: () => void;
    guideType: 'active' | 'forgotPassword';
}
const AuthNotification: React.FC<RegisterSuccessDialogProps> = ({
    title,
    open,
    guideType,
    ...props
}) => {
    const { onClose } = props;
    const { t } = useTranslation();

    const renderGuide = useMemo(() => {
        if (guideType === 'active') {
            return <img src={imgGuideActive} alt="img" />;
        } else {
            return <img src={imgGuideChangePassword} alt="img" />;
        }
    }, [guideType]);

    return (
        <BaseDialog
            maxWidth={'xl'}
            title={title}
            open={open}
            footer={false}
            onClose={onClose}
            sxContent={{
                backgroundColor: colors.backgroundColor,
                padding: '40px 70px',
            }}
        >
            <Box sx={{ color: common.black }}>
                <Box
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    marginBottom={'21px'}
                >
                    {renderGuide}
                </Box>
                <Box
                    textAlign={'center'}
                    fontSize={'14px'}
                    marginBottom={'34px'}
                >
                    <div
                        dangerouslySetInnerHTML={{
                            __html: t('register.dialog.notification.1'),
                        }}
                    />
                    <div
                        dangerouslySetInnerHTML={{
                            __html: t('register.dialog.notification.2'),
                        }}
                    />
                </Box>
                <Divider
                    sx={{
                        borderWidth: '1px',
                        backgroundColor: common.black,
                        marginBottom: '19px',
                    }}
                />
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Box sx={{ fontSize: '10px' }}>
                        <div style={{ fontWeight: 600 }}>
                            {t('common.company.name')}
                        </div>
                        {t('common.company.address')}
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <img src={facebook} alt="facebook" />
                        <img src={youtube} alt="youtube" />
                        <img src={globe} alt="globe" />
                        <img src={mail} alt="mail" />
                    </Box>
                </Box>
            </Box>
        </BaseDialog>
    );
};

export default AuthNotification;
